export const DEFAULT_CHANCEN = `Teilnahme am europäischen Aktien- und Anleihenmarkt
Flexible Anlagepolitik mit breitem Anlageuniversum
Kombination aus Value-, Event- und Anleihen-Ansatz
Risikoreduzierung durch langfristigen Value-Investmentstil`;

export const DEFAULT_RISIKEN = `Schwankungen des Aktien- und Anleihenmarktes
Verluste bis hin zum Totalverlust möglich
Auswahl- und Branchenrisiko bei Einzelwerten
Währungsrisiko bei nicht euro-denominierten Positionen`;

export const DEFAULT_RISIKEN_NOTE =
  'Ausführliche Hinweise zu Chancen und Risiken entnehmen Sie bitte dem Verkaufsprospekt.';

export const DEFAULT_RISK_INDICATOR_TEXT =
  'Der Summary Risk Indicator (SRI) ist ein Richtwert für das Risikoniveau dieses Produkts im Vergleich zu anderen Produkten. Er zeigt, wie hoch die Wahrscheinlichkeit ist, dass Sie Geld verlieren, weil sich die Märkte in einer bestimmten Weise entwickeln. Die Einstufung kann sich im Laufe der Zeit ändern. Die niedrigste Kategorie bedeutet nicht, dass eine Anlage risikofrei ist.';

export const DEFAULT_ASSET_ALLOCATION_NOTE =
  'Die Gewichtungen sind bezogen auf das Gesamtportfolio. WA = Wandelanleihe. Quellen: eigene Berechnungen / Axxion S.A.';

export const DEFAULT_PAGE3_FOOTER_NOTE =
  'Die Wertentwicklung der Vergangenheit ist kein verlässlicher Indikator für die zukünftige Wertentwicklung. Quelle: Axxion S.A.';

export const DEFAULT_ALLOKATION_AKTIEN_LEFT = [
  { label: 'Deutschland', value: 30.15 },
  { label: 'GB', value: 7.19 },
  { label: 'Frankreich', value: 6.42 },
  { label: 'Schweiz', value: 4.88 },
  { label: 'Sonstige', value: 3.21 },
];

export const DEFAULT_ALLOKATION_AKTIEN_RIGHT = [
  { label: 'Bloomsbury', value: 4.11 },
  { label: 'BTG Consulting', value: 2.5 },
  { label: 'Computacenter', value: 2.31 },
  { label: 'Norma Group', value: 2.18 },
  { label: 'Swatch Group', value: 2.05 },
];

export const DEFAULT_ALLOKATION_EVENTS_LEFT = [
  { label: 'Barmittel', value: 20.88 },
  { label: 'Nachhaltige Ernährung', value: 16.81 },
  { label: 'Events', value: 12.44 },
  { label: 'Anleihen', value: 10.92 },
];

export const DEFAULT_ALLOKATION_EVENTS_RIGHT = [
  { label: 'Allianz Hybrid', value: 2.91 },
  { label: 'TAG Immobilien', value: 2.71 },
  { label: 'Tate & Lyle', value: 2.54 },
  { label: 'Sonstige', value: 1.88 },
];

export const DEFAULT_ASSET_ALLOCATION = [
  { label: 'Aktien', value: 52 },
  { label: 'Anleihen', value: 11 },
  { label: 'Events', value: 16 },
  { label: 'Barmittel', value: 21 },
];

export const DEFAULT_MARKTKAPITALISIERUNG = [
  { label: 'Micro Caps', value: 8 },
  { label: 'Small Caps', value: 22 },
  { label: 'Mid Caps', value: 18 },
  { label: 'Large Caps', value: 31 },
  { label: 'Barmittel', value: 21 },
];

export const DEFAULT_RENDITEN_PORTFOLIODATEN = {
  left: [
    { label: 'Zins (Liquidität)', value: '1,84%' },
    { label: 'Effektiv Zins (Anleihen)*', value: '5,87%' },
    { label: '(Garantie-) Dividende (Spezialsituationen)*', value: '3,19%' },
    { label: 'Dividende (Value-Aktien)*', value: '3,69%' },
  ],
  right: [
    { label: 'Anzahl Positionen', value: '66' },
    { label: 'Summe der 10 größten Positionen', value: '29%' },
    { label: 'Summe der 25 größten Positionen', value: '53%' },
  ],
  footnote: '* Auf Basis aktueller Kurse (Hybrids: Rückzahlung zum First-Call-Date unterstellt)',
};

export { DEFAULT_KALENDERJAHR } from './kalenderjahr';

export { DEFAULT_PERFORMANCE_RISK_TABLE } from './performanceRiskTable';
export { DEFAULT_MIFID_OVERLAY, DEFAULT_MIFID_OVERLAY_NOTICE_TEXT } from './squadMifidOverlay';
